/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import { connect } from 'react-redux';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import {
  addSubCategory,
  handleUpdateOption,
  handleChangeInput,
  autocompleteChangeInput,
  getFiltredCategories,
  getFiltredSections, getSplashIngredientsFromCategory
} from './OptionModal.services';
import { returnCategories, getOriginalCategories } from '../../utils/product';
import * as actions from '../../actions/index';
import { mainColor } from '../../constants/theme';
import Input from '../Input';
import Modal from '../Modal';
import AutocompleteInput from '../AutocompleteInput';
import { styles } from './OptionModal.styles';
import OptionListCheckbox from '../OptionListCheckbox';
import Checkbox from '../Checkbox';
import { checkAccess } from '../../utils/admins';
import ShopModal from '../ShopModal';
import { handleSynchronisationToggle, getShopsToSynchronise, getSplashProductCategories } from '../../utils/shopUtils';
import { checkIntegrationAccess, hasExternalIntegration, getSplashType } from 'src/utils/externalIntegration';
import MenuSelect from '../MenuSelect';
import { SPLASH, PRODUCT } from '../../constants';
const MuiTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: mainColor.secondaryColor
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: mainColor.secondaryColor
    }
  }
})(TextField);

const INITIAL_STATE = {
  items: {},
  option: {},
  categoriesArray: [],
  isLoading: false,
  synchronize: false,
  showModal: false
};

class OptionModal extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentDidMount() {

    const { option = {}, categories, category = {} } = this.props;
    const { items = {} } = category;
    this.setState({
      items,
      option,
      categoriesArray: returnCategories(option?.subcategories || option?.categories, categories)
    });
  }
  renderShops = (classes, shopId) => {
    const { showModal, selectedShops = {}, isLoading } = this.state;
    return (
      <ShopModal
        classes={classes}
        shopId={shopId}
        showModal={showModal}
        selectedShops={selectedShops}
        loading={isLoading}
        onClick={() => handleUpdateOption(this, selectedShops)}
        handleToggle={handleSynchronisationToggle}
        component={this}
        text={'Sélectionnez les magasins dont vous voulez synchroniser ce produit:'}
        title={'Synchroniser votre produit:'}
      />
    );
  };

  render() {
    const {
      classes,
      option: initialOption = {},
      isOpen,
      closeModal,
      sections,
      categories,
      category,
      createOption, shops, shopId, categoriesPOS, sectionsPOS
    } = this.props;
    const { option, categoriesArray, synchronize, showModal, selectedShops, isLoading } = this.state;
    const { name = '', ref = '', price = '' } = option;
    const displayPrice =
      typeof price === 'number' ? String(price).replace('.', ',') : price;
    const numericPrice = parseFloat(String(displayPrice).replace(',', '.')) || 0;
    const mappedProducts = [];
    _.map(sections, section => {
      _.map(section.products, elt => {
        mappedProducts.push({ sectionKey: section?.name?.toUpperCase(), ...elt });
      });
    });
    const allCategories = _.omit(categories, category.key);
    const hasMenuPOS = checkIntegrationAccess('products', 'hasMenuPOS')
    const isPrdType = getSplashType(category.type, shopId) === PRODUCT
    const SplashIntegration = hasExternalIntegration(shopId) === SPLASH
    const selectedCategories = returnCategories(option?.subcategories || option?.categories, categories);
    const splashIngredientCategories = getSplashIngredientsFromCategory(category, categoriesPOS)
    const splashCategories = isPrdType ? getSplashProductCategories(categories, sectionsPOS) : splashIngredientCategories
    const originalCategories = getOriginalCategories(SplashIntegration ? splashCategories : categoriesPOS, ref, allCategories, !isPrdType);
    const filtredCategories = SplashIntegration ? splashCategories : _.assign(getFiltredSections(sectionsPOS, category.type), _.pickBy(categoriesPOS, elm => elm.type === category.type));
    return (
      <Modal
        color='secondary'
        title={
          createOption ? 'Créer une nouvelle option' : `Modifier ${initialOption.name || ''}`
        }
        header
        fixed
        size='md'
        showCancelBtn
        btnTxt='Enregistrer'
        modalBodyClass='py-0'
        onClick={() => {
          synchronize ?
            this.setState({
              selectedShops: { [shopId]: shops[shopId] },
              showModal: true,
            }) :
            handleUpdateOption(this, selectedShops);
        }}
        isOpen={isOpen}
        handleClose={() => closeModal()}
        loading={isLoading}
      >
        <div className={classes.modalStyle}>
          <FormControl className='col-sm d-flex justify-content-center'>
            {hasMenuPOS &&
              <MenuSelect data={filtredCategories}
                placeholder='Option de la caisse'
                item={option}
                onUpdate={(item) => { this.setState({ option: { ...item, key: option.key }, categoriesArray: returnCategories(item?.subcategories || item?.categories, categories) }) }}
                disabled={!createOption} noOptionsText="Aucune option trouvée" itemKey="categoryName"
                isPrdType={isPrdType} />
            }

          </FormControl>
          <div >
            <Input
              margin='dense'
              label={`Nom de l'option`}
              id='name'
              type='text'
              value={name}
              onChange={event => handleChangeInput(event, this)}
              fullWidth
            />
            {hasExternalIntegration() && (
              <Input
                margin='dense'
                fullWidth
                type='text'
                id='ref'
                label={`Référence de l'option`}
                value={ref}
                onChange={event => handleChangeInput(event, this)}
                disabled={checkIntegrationAccess('option', 'disableRefs')}
              />
            )}
            <FormControl className='col-sm d-flex justify-content-start'>
              <Input
                margin='dense'
                id='price'
                label={
                  <>
                    <span>Prix</span>
                    {SplashIntegration && option?.priceRef > 0 && (
                      <span className={classes.priceStyle}>
                        (Doit être inférieur ou égal à {option?.priceRef} €)
                      </span>
                    )}
                  </>
                }
                type='text'
                value={displayPrice}
                onChange={event => handleChangeInput(event, this, true)}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>€</InputAdornment>,
                  inputProps: {
                    inputMode: 'decimal'
                  }
                }}
                fullWidth
                disabled={
                  checkIntegrationAccess('option', 'disablePrice') ||
                  (SplashIntegration && option?.priceRef === 0)
                }
                error={false}
              />
            </FormControl>
            <FormControl className='col-sm  d-flex justify-content-start '>
              <AutocompleteInput
                id={option}
                options={
                  mappedProducts && mappedProducts.sort((a, b) => -b.sectionKey?.localeCompare(a.sectionKey))
                }
                groupBy={option => option.sectionKey}
                getOptionLabel={option => option?.name}
                value={mappedProducts.find(produit => produit.key === option.productKey)}
                className={classes.autocomplete}
                onChange={(e, newValue) =>
                  autocompleteChangeInput(newValue ? newValue.key : '', this)
                }
                renderInput={params => (
                  <MuiTextField
                    margin='dense'
                    {...params}
                    InputLabelProps={{ classes: { root: classes.label } }}
                    label='Associer cette option à un produit (optionnel)'
                  />
                )}
              />
              <p className='secondery-text mt-0'>
                <small>
                  * Associer une option à un produit permet de récupérer des informations
                  supplémentaires comme le stock, la disponibilité, l'image etc
                </small>
              </p>
            </FormControl>
          </div>
          {_.size(allCategories) > 0 && (
            <OptionListCheckbox
              categoriesArray={categoriesArray}
              isOptionModal
              addOption={(categoryKey, index) =>
                addSubCategory(categoriesArray, categoryKey, index, this)
              }
              category={category}
              categories={getFiltredCategories(categories, category?.type)}
              disableOption={checkIntegrationAccess('option', 'disableCheckbox')}
              selectedCategories={selectedCategories}
              productCategories={option.categories}
              originalCategories={originalCategories}
            />
          )}

          {checkAccess('features', 'globalProduct') && (
            <Checkbox
              value={synchronize}
              name='synchronize'
              text='Synchroniser cette option sur un ou plusieurs magasins'
              onClick={() => this.setState({ synchronize: !synchronize })}
              hidden={_.size(getShopsToSynchronise()) === 1}
            />
          )}
        </div>
        {showModal && this.renderShops(classes, shopId)}

      </Modal>
    );
  }
}

function mapStateToProps({ firebaseRealTime, user }) {
  const { shopId, nbShops } = user;
  const { shops, menu = {}, menuPOS = {} } = firebaseRealTime;
  const { categories = {}, sections = {} } = menu;
  const { categories: categoriesPOS = {}, sections: sectionsPOS = {} } = menuPOS;
  return {
    categories,
    sections,
    shopId,
    shops,
    nbShops,
    categoriesPOS,
    sectionsPOS
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(OptionModal));
